var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.model,
        expression: "model"
      }
    ],
    staticClass: "df-hidden",
    attrs: { type: "hidden" },
    domProps: { value: _vm.model },
    on: {
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.model = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }